import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { Button, Divider } from '@mui/material'
import * as Yup from 'yup'
import AppForm from '../form/AppForm'
import AppInput from '../form/AppInput'
import SubmitButton from '../form/SubmitButton'
import { DELETE_CONFIRM } from '../../constants/form'
import {
    addReturnOrderAdditionalCharge,
    deleteReturnOrderAdditionalCharge,
} from '../../store/actions/returnOrderAction'

const ChargeItem = ({ charge, returnOrderId }) => {
    const dispatch = useDispatch()
    const handleDelete = useCallback(
        (id) => {
            if (window.confirm(DELETE_CONFIRM)) {
                dispatch(deleteReturnOrderAdditionalCharge(id, returnOrderId))
            }
        },
        [returnOrderId, dispatch]
    )
    return (
        <TableRow>
            <TableCell>{charge?.item}</TableCell>
            <TableCell>${charge?.amount?.toFixed(2)}</TableCell>
            <TableCell>{charge?.note}</TableCell>
            <TableCell style={{ width: '50px' }}>
                <Button
                    size="small"
                    onClick={() => handleDelete(charge.id)}
                    variant="outlined"
                    color="error"
                >
                    Delete
                </Button>
            </TableCell>
        </TableRow>
    )
}

const validationSchema = Yup.object().shape({
    item: Yup.string().required().max(150).label('Charge Item'),
    amount: Yup.number().required().label('Charge Amount'),
    note: Yup.string().max(200).label('Note'),
})

const ReturnOrderAdditionalChargeForm = () => {
    const dispatch = useDispatch()
    const { returnOrder } = useSelector((state) => state.returnOrder)
    return (
        <div>
            {returnOrder?.returnorderadditionalcharges?.length > 0 && (
                <div>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Item</TableCell>
                                    <TableCell>Amount</TableCell>
                                    <TableCell>Note</TableCell>
                                    <TableCell
                                        style={{ width: '50px' }}
                                    ></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {returnOrder?.returnorderadditionalcharges?.map(
                                    (charge) => (
                                        <ChargeItem
                                            key={charge.id}
                                            charge={charge}
                                            returnOrderId={returnOrder.id}
                                        />
                                    )
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            )}
            <div style={{ marginTop: '30px' }} />
            <Divider>Add New Return Order Charge</Divider>
            <div>
                <AppForm
                    initialValues={{
                        item: '',
                        amount: '',
                        note: '',
                    }}
                    onSubmit={(values, { resetForm }) => {
                        const submitValues = {
                            ...values,
                            returnOrderId: returnOrder.id,
                        }
                        dispatch(addReturnOrderAdditionalCharge(submitValues))
                        resetForm()
                    }}
                    validationSchema={validationSchema}
                >
                    <AppInput
                        name="item"
                        label="Additional Charge Item"
                        type="text"
                        inputProps={{
                            maxLength: 150,
                        }}
                        required={true}
                    />
                    <AppInput
                        name="amount"
                        label="Amount"
                        type="number"
                        inputProps={{
                            maxLength: 10,
                        }}
                        required={true}
                    />
                    <AppInput
                        name="note"
                        label="Note"
                        type="text"
                        inputProps={{
                            maxLength: 230,
                        }}
                    />
                    <SubmitButton title="Submit" />
                </AppForm>
            </div>
        </div>
    )
}

export default ReturnOrderAdditionalChargeForm
